<nav class="nav route-nav mt-0 mb-2 mb-lg-0" #tabsContainer [ngClass]="indicatorStyle">
  <div
    [ngClass]="{
      'circle-indicator': indicatorStyle === 'rounded',
      'default-indicator': indicatorStyle === 'default',
      'd-none': !hasActive
    }"
    #indicator
  ></div>
  <ng-content select="[routerLink]"></ng-content>
</nav>
